import { Divider, Text } from '@lawpilots/design-system'
import { Box, styled } from '@mui/material'

import { useViewport } from '@/hooks'

// A card-list section heading: the DS section-label style in text-secondary with a rule filling
// the space to its right. Shared by the Training Cycles tab and the learner's assignments screen,
// which the Figma draws as the same component with different titles. On a phone the label drops to
// body size and sits closer to its rule.

const HeadingStyles = { display: 'flex', alignItems: 'center' }
const TitleStyles = { whiteSpace: 'nowrap' } as const
const Rule = styled(Divider)({ flexGrow: 1, minWidth: 0 })

export const SectionHeading = ({ title }: { title: string }): JSX.Element => {
  const compact = useViewport() === 'mobile'

  return (
    <Box sx={{ ...HeadingStyles, gap: compact ? 1 : 2 }}>
      <Text variant={compact ? 'body-reading' : 'section-label'} color="secondary" as="h2" style={TitleStyles}>
        {title}
      </Text>
      <Rule emphasis="subtle" paddingX="none" paddingY="none" />
    </Box>
  )
}
